import * as actionTypes from 'constants/ActionTypes';

export function getFlagCompliance() {
    return {
        type: actionTypes.GET_FLAG_COMPLIANCE.REQUEST,
    };
}



// WEBPACK FOOTER //
// ./app/actions/flagCompliance.js